import { CompanySettings } from "./CompanySettings/CompanySettings";
import { FollowedCompanies } from "./FollowedCompanies/FollowedCompanies";
import { NotificationsSettings } from "./NotificationSettings/NotificationsSettings";
import { UserSettings } from "./UserSettings";

export const pages = {
  "user.settings": UserSettings,
  "company.settings": CompanySettings,
  "followed.companies": FollowedCompanies,
  "notifications.settings": NotificationsSettings,
};
